import { DocumentType } from '@src/types/documentPage'

// Filter for the document-type dialog when the credit application has a co-applicant.
export type ApplicantFilter = 'applicant' | 'coapplicant' | 'all'

// Normalized co-applicant markers (lowercase, no accents, no spaces/hyphens).
// Covers English (co-applicant) and French (co-demandeur / co-emprunteur) labels.
const CO_APPLICANT_MARKERS = ['coapplicant', 'codemandeur', 'coemprunteur']

const normalize = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD') // decompose accents (é -> e + combining mark)
    .replace(/[^a-z0-9]/g, '') // strip combining marks, spaces, hyphens, punctuation

// True when the document type label (FR or EN) identifies a co-applicant document type.
export const isCoApplicantDocType = (docType: DocumentType): boolean => {
  const fr = normalize(docType.nameFr)
  const en = normalize(docType.nameEn)
  return CO_APPLICANT_MARKERS.some((marker) => fr.includes(marker) || en.includes(marker))
}

// Applies the applicant/co-applicant toggle to a list of document types.
export const filterDocTypesByApplicant = (docTypes: DocumentType[], filter: ApplicantFilter): DocumentType[] => {
  if (filter === 'all') return docTypes
  if (filter === 'coapplicant') return docTypes.filter(isCoApplicantDocType)
  return docTypes.filter((docType) => !isCoApplicantDocType(docType))
}
